import React from 'react';
import { Button } from './ui/Button';
interface HookSectionProps {
  onStart: () => void;
}
export function HookSection({
  onStart
}: HookSectionProps) {
  return <div style={{
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem'
  }} data-id="element-52">
      <header style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '1.25rem'
    }} data-id="element-53">
        <h1 style={{
        fontSize: 'clamp(1.875rem, 4vw, 2.25rem)',
        lineHeight: '1.2'
      }} data-id="element-54">
          UX Guide for Brand and Marketing Meetings
        </h1>

        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.625rem',
        fontSize: '1rem',
        lineHeight: '1.65'
      }} data-id="element-55">
          <p data-id="element-56">
            You're here because I mentioned a small book I wrote after sitting
            in too many confusing meetings.
          </p>
          <p data-id="element-57">
            It's called <em data-id="element-58">No Theory. Just the Words That Matter.</em>
          </p>
          <p data-id="element-59">
            It's a straight talking A to Z of the terms people use in brand,
            website and marketing conversations. 85+ terms defined. A bit of
            humour. The occasional bad word.
          </p>
          <p data-id="element-60">Before you download it, one quick check.</p>
        </div>

        <p style={{
        fontSize: '0.8125rem',
        color: '#8A8A85',
        lineHeight: '1.5'
      }} data-id="element-61">
          Trusted by teams, manufacturing, product-led businesses and
          professional services.
        </p>
      </header>

      <section style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '0.75rem'
    }} data-id="element-62">
        <h2 style={{
        fontSize: 'clamp(1.375rem, 3.5vw, 1.75rem)',
        lineHeight: '1.2'
      }} data-id="element-63">
          Ever left a meeting thinking… what just happened?
        </h2>
        <p style={{
        fontSize: '1rem',
        color: '#8A8A85',
        lineHeight: '1.5'
      }} data-id="element-64">
          Take two minutes before you download the guide.
        </p>
        <Button onClick={onStart} fullWidth aria-label="Start the quick check" data-id="element-65">
          Start the quick check
        </Button>
      </section>
    </div>;
}